import { render } from "./ReferralLandingPage.vue?vue&type=template&id=c2a78952&scoped=true"
import script from "./ReferralLandingPage.vue?vue&type=script&lang=js"
export * from "./ReferralLandingPage.vue?vue&type=script&lang=js"

import "./ReferralLandingPage.vue?vue&type=style&index=0&id=c2a78952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a78952"]])

export default __exports__